<template>
  <v-container fluid class="pa-0">

    <!-- General Info -->
    <v-list-item class="pa-1 ml-3">

      <v-list-item-avatar tile :size="this.isSmallDevice ? '70' : '90'">
        <v-img :src="iconPicture"></v-img>
      </v-list-item-avatar>

      <v-list-item-content :class="this.isSmallDevice ? 'ml-3' : ''">
        <v-list-item-title class="ml-4">{{ residentTitle }}</v-list-item-title>
        <v-list-item-subtitle class="ml-4">{{ kioskTitle }}</v-list-item-subtitle>
        <v-list-item-subtitle :class="`${subtitleClass} ml-4`">{{ facility.geographicalDescription }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

  </v-container>
</template>

<script>
import { AppColor, ImageUri, KioskTypeId } from '@/config.js'
import { mapGetters } from 'vuex'

export default {
  name: 'GeneralInfo',
  data() {
    return {
      // colors
      appColor_Medium: AppColor.Medium,
      appColor_HyperLink: AppColor.HyperLink,
      appColor_Abby: AppColor.KioskTypeAbbyLight,
      appColor_AbbyDark: AppColor.KioskTypeAbby,
      appColor_Genie: AppColor.KioskTypeGenieLight,
      appColor_GenieDark: AppColor.KioskTypeGenie,

      // images
      imageUri_NoAvatar: ImageUri.NoAvatar,
      imageUri_GenieKiosk: ImageUri.GenieKiosk,
      imageUri_AbbyKiosk: ImageUri.AbbyKiosk,

      // kiosk types
      kioskTypeId_Genie: KioskTypeId.Genie,
      kioskTypeId_Abby: KioskTypeId.Abby
    }
  },
  computed: {
    ...mapGetters(['activeResident', 'isAdmin']),

    iconPicture () {
      if (this.isNullOrUndefined(this.activeResident)) return null
      return this.activeResident.pictureBase64 === null
        ? this.imageUri_NoAvatar
        : this.activeResident.pictureBase64
    },
    residentTitle () {
      const name = !this.isNullOrUndefined(this.activeResident)
        ? this.activeResident.name
        : 'unknown resident'
      
        return this.isAdmin
          ? `${name} (${this.activeResident.id})`
          : name
    },
    kioskTitle () {
      return !this.isNullOrUndefined(this.kiosk)
        ? this.kiosk.name
        : 'unknown kiosk'
    },
    kiosk () {
      const unknownKiosk = {
        id: 0,
        name: 'Unknown Kiosk',
        codeName: 'UNKNOWN',
        typeId: 0
      }
      if (this.isNullOrUndefined(this.activeResident)) return unknownKiosk
      return this.activeResident.kiosk
    },
    facility () {
      const unknownFacility = {
        id: 0,
        name: 'Unknown Facility',
        code: 'UNKNOWN',
        geographicalDescription: 'Unknown Location'
      }
      if (this.isNullOrUndefined(this.activeResident)) return unknownFacility
      return this.activeResident.kiosk.facility
    },
    subtitleClass () {
      return 'grey--text text--lighten-2 font-weight-light'
    }
  }
}
</script>

<style scoped>
.wrap-text {
  word-wrap: break-word;
}
</style>